<template>
  <div class="detail-wrap">
    <el-form ref="tenant" :rules="rules" :model="tenant" :inline-message="true" class="demo-ruleForm">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}信息
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="formData.stat == 1"
                     @click="saveData">保存
          </el-button>
          <el-button  v-if="dataId && formData.stat ==1" type="primary" class="button-sty" icon="el-icon-check"
                      @click="submitById ">提交
          </el-button>
          <el-button v-if=" formData.stat == 2 " type="primary" class="button-sty" icon="el-icon-s-claim"
                     @click="check">审核
          </el-button>
          <el-button v-if=" formData.stat == 2 " type="primary" class="button-sty" icon="el-icon-s-claim"
                     @click="reject">驳回
          </el-button>
        </div>
      </div>
      <div>

        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  申请单号
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text" autocomplete="off" v-model="formData.applyNo" :disabled="true" clearable/>
                  </div>
                </td>

                <th>
                  <em class="f-red">*</em>
                  状态
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-select v-model="formData.stat" :disabled="true" clearable>
                      <el-option label="待提交" :value="1"/>
                      <el-option label="待审核" :value="2"/>
                      <el-option label="已审核" :value="5"/>
                      <el-option label="驳回" :value="9"/>
                      <el-option label="关闭" :value="99"/>
                    </el-select>
                  </div>
                </td>

                <th>
                  <em class="f-red">*</em>
                  网点
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text" autocomplete="off" v-model="formData.siteName" readonly>
                      <i slot="suffix" class="el-input__icon el-icon-search"  @click="showSitePop = true"></i>
                    </el-input>
                  </div>

                </td>

                <th>
                  <em class="f-red">*</em>
                  师傅
                </th>
                <td class="table-row">
                  <el-input type="text" autocomplete="off" v-model="formData.engineerName" readonly clearable>
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showEngineerDialog = true"></i>
                  </el-input>
                </td>
              </tr>
              <tr>
                <th><em class="f-red">*</em>请假类型</th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-select v-model="formData.applyTypeName"
                               @change="selectApplyType">
                      <el-option v-for="item in applyTypeList" :key="item.id" :label="item.label"
                                 :value="{ value: item.id, label: item.label }" />
                    </el-select>
                  </div>
                </td>

                <th><em class="f-red">*</em>开始时间</th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-date-picker v-model="formData.beginDate" type="datetime" placeholder="选择日期时间"
                                    format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </div>
                </td>

                <th><em class="f-red">*</em>结束时间</th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-date-picker v-model="formData.endDate"  type="datetime" placeholder="选择日期时间"
                                    format="yyyy-MM-dd HH:mm:ss" >
                    </el-date-picker>
                  </div>
                </td>

              </tr>
              <tr>
                <th>请假说明</th>
                <td colspan="7">
                  <div class="table-cell">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6 }" autocomplete="off"
                              maxlength="290" v-model="formData.applyRemark" clearable/>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  驳回人
                </th>
                <td class="table-row">
                  <div class="table-cell">
                  <el-input type="text" autocomplete="off" v-model="formData.rejectBy" disabled clearable />
                  </div>
                </td>
                <th>
                  驳回时间
                </th>
                <td class="table-row">
                  <div class="table-cell">
                  <el-date-picker v-model="formData.rejectTime"  type="datetime" placeholder="选择日期时间" disabled
                                  format="yyyy-MM-dd HH:mm:ss" >
                  </el-date-picker>
                  </div>
                </td>
                <th>
                  驳回备注
                </th>
                <td colspan="3">
                  <div class="table-cell">
                  <el-input type="textarea" autocomplete="off" v-model="formData.rejectRemark" disabled clearable />
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  提前复工时间
                </th>
                <td class="table-row">
                  <div class="table-cell">
                  <el-date-picker v-model="formData.tiqianFugongTime"  type="datetime" placeholder="选择日期时间" disabled
                                  format="yyyy-MM-dd HH:mm:ss" >
                  </el-date-picker>
                  </div>
                </td>
                <th>
                  提前复工备注
                </th>
                <td colspan="3">
                  <div class="table-cell">
                  <el-input type="textarea" autocomplete="off" v-model="formData.tiqianFugongRemark" disabled clearable />
                  </div>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>

              </tbody>
            </table>
          </div>
          <div>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 网点 -->
    <sitePop v-if="showSitePop" @commit="siteCommit" :visiable.sync="showSitePop" :orgId="formData.orgId"
             multi="true"/>
    <!--师傅-->
    <showEngineerDialog v-if="showEngineerDialog" @commit="commitSelectedEngRow" :siteId="formData.siteId" :visiable.sync="showEngineerDialog"
                        multi="true"/>

    <closeDialog v-if="showCloseDialog"
                 :dataId="formData.id"
                 :confirmNo="formData.applyNo"
                 type="驳回"
                 @closeD="closeD"
                 :visiable.sync="showCloseDialog"
                 multi="true"
                 @goBackIndex="goBackIndex"
    />

  </div>
</template>
<script>
import store from "@/store";
import api from "@/api/projectApi";
import {dictType, loadDictData} from "@/config/dictType";
import {mapGetters} from "vuex";
import {siteMixins} from "@/mixins/tabChang";
import sitePop from "@/views/dialogCommon/radioSiteDialog.vue";
import showEngineerDialog from '@/views/dialogCommon/radioEngineerDialog.vue';
import closeDialog from "@/views/service/wangdian/engineerHolidayApply/closeDialog.vue"

export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    initTableList: {
      type: Function,
      default: null
    }
  },
  components: {
    closeDialog,
    sitePop,
    showEngineerDialog,
  },
  data() {
    return {
      showEngineerDialog: false,
      imgVisbleURL: "",

      showPreview: false,
      videoUrl: "",

      fileList: [],

      editButton: false,
      showEdit: false,

      warehouseType: 0,
      justShow: false,
      showSitePop: false,
      showCloseDialog: false,
      isCancel: false,
      orgOptions: {},
      orgValue: "",
      formData: {
        applyNo: null,
        stat: 1, //单据状态:1制单;2审核中;5已审核;6驳回;99取消
        siteId:null,
        siteName:null,
        applyType:null,
        applyTypeName:null,

        rejectBy: null,
        rejectTime: null,
        rejectRemark: null,
      },
      applyTypeList: [],

      show3: false,
      node: true,

      isEdit: false,
      tabIndex: "first",
      dataId: "",
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api;
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId;
      return {
        Authorization: "Bearer " + store.getters.access_token,
        "TENANT-ID": tenantId,
      };
    },
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;

    this.editButton = this.permissions["holidayEdit"];
    this.submitButton = this.permissions["holidaySubmit"]; //提交
    this.checkButton = this.permissions["holidayCheck"]; //审核
    this.rejectButton = this.permissions["holidayReject"]; //驳回
    this.cancelButton = this.permissions["holidayCancel"]; //取消
  },
  mounted() {
    this.getData();
    this.loadHolidayType()
  },
  methods: {
    commitSelectedEngRow(data) {
      this.formData.engineerId = data.id
      this.formData.engineerName = data.engineerName
      this.formData.siteId = data.siteId
      this.formData.siteName = data.siteName
      console.log('获取师傅', data)
    },

    check() {
      this.$baseConfirm("您确定要审核吗？").then(() => {
        this.$http.post("/basic/engineerHolidayApply/check", {
          id: this.formData.id
        }).then((res) => {
          this.$message.success("审核成功！");
          this.reload();
          this.$mask.close();
        });
      })
    },
    reject() {
      this.showCloseDialog = true
    },
    // 返回列表页
    goBackIndex() {
      this.$emit("goBackIndex");
    },

    // 抽屉关闭
    closeD() {
      this.showCloseDialog = false;
    },
    // 加载tab数据 假期类型数据初始化
    loadHolidayType() {
      loadDictData("请假类型").then(res => {
        this.applyTypeList = []
        res.data.data.forEach(item => {
          this.applyTypeList.push({
            label: item.label,
            id: item.id
          })
        })
      })
    },
    selectApplyType(data) {
      this.formData.applyType = data.value;
      this.formData.applyTypeName = data.label;
    },

    // 网点弹框选中
    siteCommit(data) {
      console.log("选中的网点", data);
      this.formData.siteId = data.id;
      this.formData.siteName = data.name;
      this.orgValue = data.orgId;
      this.formData.orgId = data.orgId;
      this.formData.orgName = data.orgName;
      this.formData.orgIdPath = data.orgIdPath;
    },

    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    saveData() {
      console.log("保存数据", this.formData);
      if (this.formData.engineerName == null || this.formData.engineerName == "") {
        this.$message.error("师傅不能为空！");
        return false;
      }

      if (!this.formData.applyType) {
        this.$message.error("请假类型不能为空！");
        return false;
      }

      if (
        this.formData.beginDate == null ||
        this.formData.beginDate == ""
      ) {
        this.$message.error("请假开始时间不能为空！");
        return false;
      }

      if (
        this.formData.endDate == null ||
        this.formData.endDate == ""
      ) {
        this.$message.error("请假结束时间不能为空！");
        return false;
      }

      const d = new Date(this.formData.endDate);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      this.formData.endDate =  `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      const c = new Date(this.formData.beginDate);
      const year2 = d.getFullYear();
      const month2 = String(c.getMonth() + 1).padStart(2, '0');
      const day2 = String(c.getDate()).padStart(2, '0');
      const hours2 = String(c.getHours()).padStart(2, '0');
      const minutes2 = String(c.getMinutes()).padStart(2, '0');
      const seconds2 = String(c.getSeconds()).padStart(2, '0');
      this.formData.beginDate =  `${year2}-${month2}-${day2} ${hours2}:${minutes2}:${seconds2}`;

      this.formatDate(this.formData.endDate)

      if ( this.formData.beginDate> this.formData.endDate){
        this.$message.error("请假开始时间不能大于结束时间！");
        return false;
      }
      this.$baseConfirm("您确定要保存吗？").then(() => {
        this.$mask.open();
        var url = this.isEdit
          ? "/basic/engineerHolidayApply/update"
          : "/basic/engineerHolidayApply/add";
        var method = "post";
        this.$http({
          url: url,
          method: method,
          data: this.formData,
          isLoading: true,
        }).then((response) => {
          this.$message.success("保存成功！");
          this.reload();
          this.$mask.close();
        })
          .catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close();
          });
      });

    },

    submitById(id){
      this.$baseConfirm("您确定要提交吗？").then(() => {
        this.$http.get(" /basic/engineerHolidayApply/submitById", {
          params: {
            id: this.formData.id
          }
        })
          .then(response => {
            if(response.data.data.type == 'success'){
              this.$message.success("提交成功")
              this.flushed()
            }else{
              this.$message.error("提交失败！");
            }
          })
      })

    },

    getData() {
      // console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: "/basic/engineerHolidayApply/getById?id=" + this.dataId,
          method: "get",
          isLoading: true,
          modalStrictly: true,
        }).then((response) => {
          let data = response.data.data;
          this.formData = response.data.data;
        });
      } else {
        //新建
        this.enabled = true;
        if (this.currentSiteData !== null) {
          //网点端
          console.log("this.currentSiteData", this.currentSiteData);
          this.formData.siteName = this.currentSiteData.userName;
          this.formData.siteId = this.currentSiteData.id;
          this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId;
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId;
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName;
          this.formData.orgIdPath =
            this.currentSiteData.snSiteInfoDTO.orgIdPath;
        }
      }
    },

  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.table-row {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.table-cell {
  flex: 1;
  margin-right: 10px;
}

</style>
